import React from 'react';
import { useHistory, Link } from 'react-router-dom';
import { Breadcrumb, message } from 'antd';
import { PageContainer } from '@ant-design/pro-layout';
import { ProFormSelect, ProFormText } from '@ant-design/pro-form';
import ProForm from '../../layout/ProForm';
import { useMutation } from '@apollo/client';
import { ADD_FACULTY, GET_FACULTIES } from '../../../gql/faculties';
import { useLoading } from '../../../hooks';
import { ENUM_FACULTY_CONTROL_TYPE } from 'constants/form';

const AddFaculty = () => {
  const history = useHistory();
  const [addFaculty, { loading }] = useMutation(ADD_FACULTY, {
    refetchQueries: [
      { query: GET_FACULTIES, variables: { state: 'ALL' } },
      { query: GET_FACULTIES, variables: { state: 'ACTIVE' } },
    ],
    onCompleted: ({ addFaculty }) => {
      history.push('/system-setting/faculties');
      message.success(`${addFaculty.name} successfully added`);
    },
    onError: (err) => {
      console.log(err);
    },
  });
  useLoading(loading);

  return (
    <PageContainer
      header={{
        title: 'Add Faculty',
        breadcrumb: (
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/system-setting/faculties">Faculties</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Add Faculty</Breadcrumb.Item>
          </Breadcrumb>
        ),
      }}
    >
      <ProForm
        onFinish={(input) => {
          addFaculty({
            variables: {
              addFacultyInput: input,
            },
          });
        }}
        submitter={{
          searchConfig: {
            resetText: 'Reset',
            submitText: 'Submit',
          },
        }}
      >
        <ProFormText
          width="xl"
          name="name"
          label="Name"
          rules={[{ required: true, message: 'Please enter faculty name!' }]}
        />
        <ProFormText
          width="xl"
          name="abbreviation"
          label="Abbreviation"
          rules={[
            { required: true, message: 'Please enter faculty abbreviation!' },
          ]}
        />
        <ProFormSelect
          width="xl"
          name="controlType"
          label="Control Type for Annual report reminder"
          rules={[{ required: true, message: 'Please select control type!' }]}
          valueEnum={ENUM_FACULTY_CONTROL_TYPE}
        />
      </ProForm>
    </PageContainer>
  );
};

export default AddFaculty;
